import { render } from "./BiaoZhunView.vue?vue&type=template&id=944dcb02&scoped=true&ts=true"
import script from "./BiaoZhunView.vue?vue&type=script&lang=ts"
export * from "./BiaoZhunView.vue?vue&type=script&lang=ts"

import "./BiaoZhunView.vue?vue&type=style&index=0&id=944dcb02&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-944dcb02"]])

export default __exports__